import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para alguien que nunca cocinó para vender?',
  a: 'Sí. Los 6 tomos están diseñados desde cero. No se asume ningún conocimiento previo. Las recetas tienen pasos numerados, temperaturas exactas, tablas de problemas y soluciones y checklists para que no quede nada librado al azar.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en PDF. Al confirmar el pago recibís un email con el link de descarga en menos de 5 minutos. Compatible con cualquier celular, tablet o computadora. No necesitás ningún programa especial.'
}, {
  q: '¿Necesito horno profesional o batidora industrial?',
  a: 'No. Todo el Megapack está desarrollado y probado en horno convencional de gas doméstico. Las técnicas están adaptadas para cocina de casa argentina sin maquinaria especial.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, escribís a soportebibliodigital@gmail.com y te devolvemos el 100% del pago. Sin preguntas. Sin formularios.'
}, {
  q: '¿Qué lo diferencia de las recetas de YouTube o Instagram?',
  a: 'Las recetas de internet no calculan costos argentinos, no tienen estrategia de venta, no incluyen el precio de los insumos locales y no están optimizadas para horno doméstico de gas. Este Megapack es un sistema completo: receta + costo + precio + venta + marketing. Todo junto, en un solo lugar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-white" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 font-serif" data-id="element-85">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-86">
          {faqs.map((faq, i) => <div key={i} className="border border-cream-dark rounded-2xl overflow-hidden bg-cream-light/50" data-id="element-87">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-88">
                <span className="font-bold text-carbon pr-4" data-id="element-89">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-green transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-90" />
              </button>

              <AnimatePresence data-id="element-91">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-92">
                    <div className="px-6 pb-4 text-carbon-lighter text-sm leading-relaxed border-t border-cream-dark/50 pt-4" data-id="element-93">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}